export enum ArticlePageProductTeaserVariant {
    UNIQUE_INSTANCES = 'UNIQUE_INSTANCES',
    FUTURE_RELEASE = 'FUTURE_RELEASE'
}
